import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '.appmodal'
})
export class ModalDirective {
    @HostBinding('class.inmodal') private _addInModal = false;
    @HostBinding('class.modal') private _addModal = false;
    @HostBinding('style.display') display : string = "block";
    constructor() { }

    addModal(modal: boolean) {
        this._addInModal = modal;
        this._addModal = modal;
        this.display = "block";
    }
}
